import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleCards() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold uppercase tracking-wide mb-4">
            SEO Guides & Articles
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-4">
            Sugargoo Spreadsheet Knowledge Base
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm md:text-base">
            Explore our collection of in-depth guides covering everything about Sugargoo spreadsheets, shopping strategies, shipping, and more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-white rounded-xl border border-background-200 hover:border-primary-300 overflow-hidden transition-all duration-300 cursor-pointer animate-fade-in-up flex flex-col"
              style={{ animationDelay: `${index * 80}ms` }}
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-white/90 text-foreground-800 text-xs font-semibold backdrop-blur-sm">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading font-semibold text-foreground-900 text-sm md:text-base mb-2 line-clamp-2 group-hover:text-primary-700 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs md:text-sm leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-100">
                  <span className="text-xs text-foreground-400 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                  <span className="text-xs text-primary-600 font-medium flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read Article
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}